import { render } from "./BaliseSelect.vue?vue&type=template&id=2bb404e1&scoped=true"
import script from "./BaliseSelect.vue?vue&type=script&lang=js"
export * from "./BaliseSelect.vue?vue&type=script&lang=js"

import "./BaliseSelect.vue?vue&type=style&index=0&id=2bb404e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb404e1"]])

export default __exports__